export default "__VITE_ASSET__5e32315e__"